
/*
    Right now this exists entirely as a semantic placeholder
    I might choose to deprecate this at some point
*/

import React from "react";

class SubNav extends React.Component {
    render(){
        return (
            <div className="subnav">
                {this.props.children}
            </div>
        );
    }
}

export default SubNav;